import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { IClient } from '~/types/client';
import { useLanguageManager } from '~/hooks/useLanguageManager';
import { useSentryContext } from '~/hooks/useSentryContext';
import { useSentrySocketBreadcrumbs } from '~/hooks/useSentrySocketBreadcrumbs';

import { ScreenForInstance } from './ScreenForInstance';
import { WarningPage } from '../WarningPage/WarningPage';

export function ScreenManager({ client }: { client: IClient }) {
    useLanguageManager();
    useSentryContext({ clientID: client.id, deviceType: 'screen' });
    useSentrySocketBreadcrumbs();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    const device = searchParams.get('device') || 'anim';
    const gameID = searchParams.get('game') || 'geoloc';

    if (!device) {
        return (
            <WarningPage message={t('console.error.noInstance.title')}>
                <p>{t('console.error.noInstance.message')} </p>
            </WarningPage>
        );
    }

    const screenID = client.getScreenForDevice(device);
    // gameID = gameID || client.getGameForDevice(device) || '';

    if (device !== 'anim' && !screenID) {
        return (
            <WarningPage message={t('console.error.noScreen.title')}>
                <p>
                    {t('console.error.noScreen.message')} <span className="tag">{device}</span>
                </p>
            </WarningPage>
        );
    }

    if (!gameID) {
        return (
            <WarningPage message={t('console.error.noGame.title')}>
                <p>
                    {t('console.error.noGame.message')} <span className="tag">{device}</span>
                </p>
            </WarningPage>
        );
    }

    return <ScreenForInstance clientID={client.id} gameID={gameID} screenID={screenID} />;
}
